import React from "react";

import WhatsNew from "../../../../Frontend/Container/pages/Home/WhatsNew";
import CaseManagementHome from "../../../../Frontend/Container/pages/Home/CaseManagementHome/CaseManagementHome";
import UsefulLinks from "../../../../Frontend/Container/pages/Home/CaseManagementHome/UsefulLinks";
import HomeBanner from "../../../../Frontend/Container/pages/Home/HomeBanner";

function HomeChennai({ benchId, benchName }) {
  return (
    <>
      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
        <HomeBanner benchId={7} />
        {/* <WhatsNew benchId={7} /> */}
        <CaseManagementHome />
      </div>
      <UsefulLinks />
    </>
  );
}

export default HomeChennai;
